/*
 * @providesModule StoreFrontStore
 *
 */

import MinFlux from 'min-flux';
import RESTStore from 'RESTStore';
import {NativeModules, Platform} from 'react-native';
import SKZCloudGaming from 'SKZCloudGaming';

const SKZAPIManager = NativeModules.SKZAPIManager;

const ANDROID_VC_PLATFORM = 'GOOGLE';
const IOS_VC_PLATFORM = 'APPLE';
const V2_STORE_VC_PARAM = 'virtual_currency_platform';
const STORE_ENDPOINT = '/v2/store';

const StoreFrontStore = new MinFlux.Store({
  getDepositOffers(): any {
    return this._data;
  },

  fetchStoreInfo(useCache: boolean, completion: (error: Object, response: Object) => {}) {
    const handleResponse = (response: Object, error: string) => {
      if (error && completion) {
        completion(error, null);
        return;
      }

      const isCloudGaming = SKZCloudGaming.getConstants().isCloudGaming;
      const data = response;

      if (isCloudGaming) {
        console.debug('filtering incentives for cloud gaming');

        // remove store info for offers related to ads from payload before returning.
        data.incentives = data.incentives.filter((inc) => inc.type !== 'AD');
      }

      if (completion) {
        this._data = data;
        completion(null, data);
      }
    };

    const params = {
      [V2_STORE_VC_PARAM]: Platform.OS === 'android' ? ANDROID_VC_PLATFORM : IOS_VC_PLATFORM,
    };
    if (useCache) {
      console.debug('fetch store with cache');
      RESTStore.getAnyResponse(
        STORE_ENDPOINT,
        params,
        SKZAPIManager.OnError.promptRetry,
        handleResponse
      );
    } else {
      console.debug('fetch store without cache');
      RESTStore.getServerResponse(
        STORE_ENDPOINT,
        params,
        SKZAPIManager.OnError.promptRetry,
        handleResponse
      );
    }
  },

  fetchDepositOffers: function (bypassCache) {
    const params = {
      virtualCurrencyPlatform: Platform.select({
        android: 'GOOGLE',
        ios: 'APPLE',
      }),
    };
    if (!bypassCache) {
      RESTStore.getAnyResponse('store/', params, SKZAPIManager.OnError.promptRetry, (payload) => {
        this._data = payload;
        this.emitChange();
      });
    } else {
      RESTStore.getServerResponse(
        'store/',
        params,
        SKZAPIManager.OnError.promptRetry,
        (payload) => {
          this._data = payload;
          this.emitChange();
        }
      );
    }

    console.warn(
      'Store Front Action Creator / Store flow is deprecated, use fetchDepositOffersWithCompletion'
    );
  },

  fetchDepositOffersWithCompletion: function (useCache: boolean = false, completion: Function) {
    const params = {
      [V2_STORE_VC_PARAM]: Platform.OS === 'android' ? ANDROID_VC_PLATFORM : IOS_VC_PLATFORM,
    };
    const getResponse = useCache ? RESTStore.getAnyResponse : RESTStore.getServerResponse;
    getResponse.bind(RESTStore)(
      STORE_ENDPOINT,
      params,
      SKZAPIManager.OnError.promptRetry,
      (payload) => {
        if (completion) {
          completion(payload);
        }
      }
    );
  },

  actionTypeHandlers: {
    FETCH_DEPOSIT_OFFERS: function (action) {
      this.fetchDepositOffers(action.payload.bypassCache);
    },
  },
});

export default StoreFrontStore;
